import { type Directive } from "vue";

const DateMonthYearFormatDirective: Directive = {
  mounted(el: HTMLInputElement, binding) {
    el.setAttribute("autocomplete", "false");
    el.addEventListener("input", (event) => {
      const input = event.target as HTMLInputElement;
      if (!(input.value === input.dataset.invalid)) {
        delete input.dataset.invalid;
      }
      // check if slash is added
      const isSlash =
        input.value.length > 0 && input.value[input.value.length - 1] === "/";
      let value = input.value.replace(/\D/g, "");
      const oldValue = input.dataset.oldValue || "";
      const isBackspace = oldValue.length > value.length;
      const inputElement = event.target as HTMLInputElement;
      let cursorPosition = inputElement.selectionStart ?? 0;
      cursorPosition = cursorPosition > 0 ? cursorPosition : 0;
      let cursorPositionB4Back = inputElement.selectionStart ?? 0;

      if (isSlash) {
        // add zero in front
        if (value.length === 1 && value[0] !== "0") {
          value = "0" + value;
        }

        if (value.length === 3 && value[2] !== "0") {
          const day = value.slice(0, 2);
          const month = value.slice(2);
          value = day + "0" + month;
        }
      }

      if (value.length > 2) {
        const day = value.slice(0, 2);
        let month = value.slice(2, 4);
        let year = value.slice(4);

        // If the month is greater than 12, keep it as is
        if (Number(month) > 12) {
          document.execCommand("insertText", false, "");
          // month = "12";
        }

        value =
          day +
          (month.length > 0 ? "/" + month : "") +
          (year.length > 0 ? "/" + year : "");
        // let cursorPosition2 = inputElement.selectionStart ?? 0;

        if (
          cursorPosition === 3 ||
          (cursorPosition == 5 && cursorPositionB4Back != 5)
        ) {
          cursorPosition = cursorPosition > 0 ? cursorPosition + 1 : 0;
          setTimeout(() => {
            input.setSelectionRange(cursorPosition, cursorPosition);
          }, 0);
        } else if (cursorPosition >= 5 && input.value[cursorPosition] === "/") {
          cursorPosition = cursorPosition > 0 ? cursorPosition + 1 : 0;
        }

        input.dataset.oldValue = value;
      } else if (
        (value.length === 2 && !isBackspace) ||
        (value.length === 2 && isSlash)
      ) {
        console;
        value = value + "/";
      }

      if (value.length > 5) {
        const day = value.slice(0, 2);
        const month = value.slice(3, 5);
        const year = value.slice(6);
        value = day + "/" + month + (year.length > 0 ? "/" + year : "");
        cursorPosition = cursorPosition > 0 ? cursorPosition : 0;

        setTimeout(() => {
          input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
      } else if (value.length === 5 && !isBackspace) {
        value = value + "/";
      }

      const isBackspace2 = oldValue.length > value.length;

      if (isBackspace2) {
        if (value.length >= 4) {
          if (
            cursorPosition == 5 ||
            cursorPositionB4Back == 4 ||
            cursorPosition == 1 ||
            cursorPosition >= 7
          ) {
            cursorPosition = cursorPosition > 0 ? cursorPosition : 0;
            setTimeout(() => {
              input.setSelectionRange(cursorPosition, cursorPosition);
            }, 0);
          } else if (cursorPosition == 6) {
            cursorPosition = cursorPosition > 0 ? cursorPosition : 0;
            setTimeout(() => {
              input.setSelectionRange(cursorPosition, cursorPosition);
            }, 0);
          } else {
            cursorPosition = cursorPosition > 0 ? cursorPosition - 1 : 0;
            setTimeout(() => {
              input.setSelectionRange(cursorPosition, cursorPosition);
            }, 0);
          }
        } else {
          cursorPosition = cursorPosition > 0 ? cursorPosition : 0;
          setTimeout(() => {
            input.setSelectionRange(cursorPosition, cursorPosition);
          }, 0);
        }
      }

      const [day, month, year] = value.split("/").map(Number);

      // Check if the entered date is valid
      const isValidDate =
        !isNaN(day) &&
        !isNaN(month) &&
        !isNaN(year) &&
        day > 0 &&
        month > 0 &&
        year > 0 &&
        month <= 12 &&
        day <= new Date(year, month, 0).getDate();

      if (
        value.length >= 10 &&
        (!isValidDate || day > new Date(year, month, 0).getDate())
      ) {
        // If the entered date is invalid or the day exceeds the number of days in the month,
        //set dataset.invalid
        input.dataset.invalid = value.substring(0, 10);
      }

      if (isSlash && value.length === 5) {
        value = value.slice(0, 10) + "/";
      }

      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      input.dataset.oldValue = value.substring(0, 10);
      input.value = value.substring(0, 10);
      inputElement.dispatchEvent(new Event("input"));
    });

    el.addEventListener("paste", async (event) => {
      event.preventDefault(); // Prevent the default paste behavior
      const input = event.target as HTMLInputElement;
      try {
        const clipboardData = event.clipboardData;
        const pastedText = clipboardData?.getData("Text");
        if (!pastedText) {
          return;
        }

        // Replace dashes with slashes
        const formattedText = pastedText.replace(/-/g, "/");

        const [day, month, year] = formattedText.split("/").map(Number);
        const isValidDate =
          !isNaN(day) &&
          !isNaN(month) &&
          !isNaN(year) &&
          day > 0 &&
          month > 0 &&
          year > 0 &&
          month <= 12 &&
          day <= new Date(year, month, 0).getDate();
        if (!isValidDate || day > new Date(year, month - 1, 0).getDate()) {
          // If the entered date is invalid or the day exceeds the number of days in the month, clear the inputValue
          document.execCommand("insertText", false, formattedText);
          input.dataset.invalid = formattedText;
        } else {
          document.execCommand("insertText", false, formattedText);
        }
      } catch (error) {
        console.error("Failed to read clipboard data: ", error);
      }
    });
  },
};

export default DateMonthYearFormatDirective;
